// extracted by mini-css-extract-plugin
export default {"sunburstTitleTexts":"sunburstTitleTexts_sunburstTitleTexts__vGi4t"};